export default "__VITE_ASSET__0f8628fd__"